import React, { useEffect, useState } from 'react';
import { AlertTriangle, Video } from 'lucide-react';
import { axios, auth, mbUrl, muted, primary } from './mbApi';

export const BriefImage = ({ ibId, id }) => {
  const [src, setSrc] = useState('');
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let url = '';
    axios.get(mbUrl(ibId, `/brief-images/${id}`), { ...auth(), responseType: 'blob' })
      .then((r) => { url = URL.createObjectURL(r.data); setSrc(url); })
      .catch(() => setFailed(true));
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [ibId, id]);
  if (failed) return <div className={`h-20 w-20 rounded border border-[hsl(var(--border))] text-[10px] ${muted} flex items-center justify-center`}>Gagal muat</div>;
  return (
    <a href={src || undefined} target="_blank" rel="noopener noreferrer" data-testid={`mb-brief-image-${id}`}>
      {src ? <img src={src} alt="Gambar rujukan brief" className="h-20 w-20 object-cover rounded border border-[hsl(var(--border))] hover:opacity-80 transition-opacity" />
        : <div className="h-20 w-20 rounded bg-white/5 animate-pulse" />}
    </a>
  );
};

export const BriefImages = ({ ibId, ids, testid }) => (ids || []).length > 0 && (
  <div className="flex flex-wrap gap-2" data-testid={testid}>{ids.map((id) => <BriefImage key={id} ibId={ibId} id={id} />)}</div>
);

export const VideoLinks = ({ links }) => (links || []).map((l) => (
  <a key={l} href={l} target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 underline break-all"><Video size={11} className="shrink-0" />{l}</a>
));

export const RefWarning = ({ refs, images, videos }) => {
  const missing = [!refs && 'Link rujukan', !images && 'Gambar rujukan', !videos && 'Link video rujukan'].filter(Boolean);
  if (!missing.length) return <p className="text-[11px] text-emerald-400" data-testid="mb-ref-ok">Rujukan lengkap: link, gambar & video ada.</p>;
  return (
    <p className="text-[11px] text-amber-400 flex items-start gap-1" data-testid="mb-ref-warning">
      <AlertTriangle size={14} className="shrink-0 mt-0.5" />
      <span>Rujukan disyorkan (tidak wajib), belum ada: <span className={primary}>{missing.join(', ')}</span>. Brief tetap boleh disimpan & diserah; video rujukan hanya perlu untuk brief video. Gambar hanya dari PDF (tampal gambar dalam template).</span>
    </p>
  );
};
